var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4.83043C13 3.36304 11.3027 2.54726 10.1568 3.4639L6.07931 6.7259C5.85766 6.90321 5.58227 6.99981 5.29844 6.99981H3.75C2.23122 6.99981 1 8.23103 1 9.74981V14.2498C1 15.7686 2.23122 16.9998 3.75 16.9998H5.29844C5.58234 16.9998 5.85777 17.0965 6.07932 17.2738L10.1568 20.5357C11.3026 21.4522 13 20.6367 13 19.1692V4.83043ZM11.0938 4.63523C11.2575 4.50424 11.5 4.62082 11.5 4.83043V19.1692C11.5 19.3787 11.2576 19.4954 11.0938 19.3644L7.01634 16.1025C6.52865 15.7122 5.92278 15.4998 5.29844 15.4998H3.75C3.05964 15.4998 2.5 14.9402 2.5 14.2498V9.74981C2.5 9.05946 3.05964 8.49981 3.75 8.49981H5.29844C5.92288 8.49981 6.52874 8.28729 7.01635 7.8972L11.0938 4.63523Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4194 7.58081C16.1265 7.28792 15.6517 7.28792 15.3588 7.58081C15.0659 7.8737 15.0659 8.34858 15.3588 8.64147C16.2192 9.50187 16.75 10.6883 16.75 12.0002C16.75 13.3121 16.2192 14.4986 15.3588 15.359C15.0659 15.6519 15.0659 16.1268 15.3588 16.4197C15.6517 16.7125 16.1265 16.7125 16.4194 16.4197C17.5496 15.2894 18.25 13.7259 18.25 12.0002C18.25 10.2745 17.5496 8.71101 16.4194 7.58081Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeHalf);
export default __webpack_public_path__ + "static/media/volume-half.97d2b8919411dece698d5ca36e85d718.svg";
export { ForwardRef as ReactComponent };